<template>
  <div id="add-document-footer">
    <p class="footer-text p-2">
      พบ {{ data?data.length:orders.length }} รายการ
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "AddDocumentFooter",
    props: {
        data: {}
    },
    computed: {
        ...mapGetters({
            orders: "Account/getFilterOrders"
        })
    },
    data() {
        return {
            length: 0
        };
    },
    created() {
    }
};
</script>

<style scoped>
#add-document-footer {
    background-color: #eaeced;
    text-align: left;
}
.footer-text {
    /*margin: 2rem;*/
}
</style>
